// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".QvBM7ewR6tBXdY5XaN5_x {\n  width: 100%;\n  margin: 0 auto;\n}\n\n@media (max-width: 767px) {\n  .QvBM7ewR6tBXdY5XaN5_x {\n    width: 100%;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"interviews": "QvBM7ewR6tBXdY5XaN5_x"
};
module.exports = exports;
